<script setup lang="ts">
import { runCommand } from '@/commands/registry'
import { ref } from 'vue'
import { useDocumentStore, type Anchor } from '@/stores/documentStore'
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { MAX_DOCUMENT_DIMENSION } from '@/types/document'

const emit = defineEmits<{ close: [] }>()
useModal('canvas-size')
const { t } = useI18n()
const docStore = useDocumentStore()
const cur = docStore.doc!.meta
const width = ref(cur.width)
const height = ref(cur.height)
const anchor = ref<Anchor>('c')
const anchors: Anchor[] = ['tl', 't', 'tr', 'l', 'c', 'r', 'bl', 'b', 'br']
function run() {
  if (!(width.value >= 1 && height.value >= 1 && width.value <= MAX_DOCUMENT_DIMENSION && height.value <= MAX_DOCUMENT_DIMENSION)) return
  void runCommand('image.canvasSize', { width: width.value, height: height.value, anchor: anchor.value })
  emit('close')
}
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')" @keydown.enter="run">
      <h2>{{ t('dialog.canvas.title') }}</h2>
      <div class="field"><span>{{ t('dialog.canvas.current') }}</span><span class="mono">{{ cur.width }} × {{ cur.height }} px</span></div>
      <label class="field"><span>{{ t('dialog.new.width') }}</span><span class="row"><input v-model.number="width" type="number" min="1" :max="MAX_DOCUMENT_DIMENSION" autofocus /> px</span></label>
      <label class="field"><span>{{ t('dialog.new.height') }}</span><span class="row"><input v-model.number="height" type="number" min="1" :max="MAX_DOCUMENT_DIMENSION" /> px</span></label>
      <div class="field"><span>{{ t('dialog.canvas.anchor') }}</span>
        <div class="anchors">
          <button v-for="a in anchors" :key="a" class="anchor" :class="{ active: anchor === a }" @click="anchor = a">{{ anchor === a ? '●' : '○' }}</button>
        </div>
      </div>
      <div class="actions">
        <button @click="emit('close')">{{ t('dialog.cancel') }}</button>
        <button class="primary" @click="run">{{ t('dialog.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.anchors {
  display: grid;
  grid-template-columns: repeat(3, 26px);
  gap: 2px;
}
.anchor {
  width: 26px;
  height: 26px;
  padding: 0;
}
.anchor.active {
  color: var(--accent-hi);
}
</style>
